module.exports = __webpack_public_path__ + "img/Tree vine@2x.27deaf8c.png";